import React from 'react';
import styles from './TextSection.module.css';
import {
    OptimizedMotionH2,
    OptimizedMotionP,
} from '../../../shared/ui/optimized-motion/OptimizedMotion';

const TextSection: React.FC = () => {
    return (
        <div className={styles.container}>
            <OptimizedMotionH2 type="slide-down" delay={0.1} className={styles.title}>
                Cross‑Functional <br />
                Alignment
            </OptimizedMotionH2>
            <OptimizedMotionP type="slide-down" delay={0.4} className={styles.text}>
                Shared calendars display campaign timelines alongside individual task owners.
                Everyone understands dependencies and launch dates. Built‑in analytics show each
                role how their work drives the bigger picture, transforming siloed specialists into
                a cohesive growth squad.
            </OptimizedMotionP>
            <div className={styles.blur1}></div>
            <div className={styles.blur2}></div>
        </div>
    );
};

export default TextSection;
